import { map as Rmap } from "ramda";
import api from "@/api";
import { find as Rfind, propEq as RpropEq } from "ramda";
import { JSConn } from "@/utilities/js-conn";

interface LotUnit {
  description: string;
  id: string;
  name: string;
  status?: string;
}

interface LotUnitState {
  lotUnits: LotUnit[];
  lotUnit: LotUnit | {};
}

const emptyLotUnit: LotUnit = {
  id: "",
  name: "",
  description: "",
};

const itemDetails = {
  pluralName: "lot_units",
  singularName: "lot_unit",
};

const apiParamsBuilder = (jsConn: JSConn) => {
  return {
    id: jsConn.formParams.id,
    lot_unit: {
      ...jsConn.formParams,
    },
  };
};

const state: LotUnitState = {
  lotUnits: [],
  lotUnit: {},
};

const mutations = {
  LOAD_LOT_UNITS(state: LotUnitState, payload: LotUnit[]) {
    state.lotUnits = payload;
  },
  LOAD_LOT_UNIT(state: LotUnitState, payload: LotUnit) {
    state.lotUnit = payload;
  },
};

const actions = {
  needLotUnits(context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return api.getItems(jsConn, itemDetails).then(jsConn => {
      context.commit("LOAD_LOT_UNITS", jsConn.response);
    });
  },
  needLotUnit(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api.getItem(jsConn, itemDetails).then(jsConn => {
      context.commit("LOAD_LOT_UNIT", jsConn.response);
    });
  },
  createLotUnit(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .createItem(jsConn, itemDetails)
      .then(jsConn => {
        context.commit("LOAD_LOT_UNIT", jsConn.response);
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  },
  updateLotUnit(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .updateItem(jsConn, itemDetails)
      .then(jsConn => {
        context.commit("LOAD_LOT_UNIT", jsConn.response);
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  },
  deleteLotUnit(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);

    return api
      .deleteItem(jsConn, itemDetails)
      .then(jsConn => {
        context.commit("LOAD_LOT_UNIT", emptyLotUnit);
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  },
};

const getters = {
  lotUnits: (state: LotUnitState) => {
    return state.lotUnits;
  },
  lotUnit: (state: LotUnitState) => {
    return state.lotUnit;
  },
  lotUnitsForTable: (state: LotUnitState) => {
    return state.lotUnits;
  },
  lotUnitsForAutocomplete: (state: LotUnitState) => {
    // map over the items and just return a label and an id
    return Rmap(lotUnit => {
      return {
        value: lotUnit.id,
        label: lotUnit.name,
      };
    }, state.lotUnits);
  },
  lotUnitById: (state: LotUnitState) => (id: string) => {
    return Rfind(lotUnit => {
      return RpropEq("id", id, lotUnit);
    }, state.lotUnits);
  },
};

const lotUnitsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default lotUnitsModule;
